var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPresentationChartBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none",
  viewBox: "0 0 26 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.4 4c0-.47.38-.85.85-.85h19.5a.85.85 0 1 1 0 1.7h-.233V16c0 1.084-.931 1.85-1.934 1.85h-5.409l2.736 2.525a.85.85 0 1 1-1.153 1.25L13 18.157l-3.757 3.468a.85.85 0 1 1-1.153-1.25l2.736-2.525h-5.41c-1.002 0-1.933-.766-1.933-1.85V4.85H3.25A.85.85 0 0 1 2.4 4m2.783.85V16c0 .018.007.048.044.082a.28.28 0 0 0 .19.068h15.166c.086 0 .151-.032.19-.067.037-.035.044-.065.044-.083V4.85zm12.15 2.3c.47 0 .85.38.85.85v5a.85.85 0 0 1-1.7 0V8c0-.47.38-.85.85-.85M13 9.15c.47 0 .85.38.85.85v3a.85.85 0 1 1-1.7 0v-3c0-.47.38-.85.85-.85m-4.333 2c.47 0 .85.38.85.85v1a.85.85 0 0 1-1.7 0v-1c0-.47.38-.85.85-.85",
  clipRule: "evenodd"
})));
export default SvgPresentationChartBar;